import { isMobileLayout } from '../../../components/styles/responsive';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class MePathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { path } = this.context;

    if (path.startsWith('/me') && isMobileLayout()) {
      const defaultState = this.getDefaultState();

      const route = (defaultState?.routes[1] ?? defaultState?.routes[0])?.state
        ?.routes[0];

      const routeName = route?.name ?? 'main';
      const routeState = route?.state;

      let index = 0;

      const routes = [
        {
          name: routeName,
          state: routeState,
        },
      ];

      if (routeName !== 'main') {
        routes.unshift({ name: 'main', state: undefined });
        index = 1;
      }

      return {
        routes: [
          {
            name: 'home',
            state: {
              routes: [
                {
                  name: 'user',
                  state: {
                    index,
                    routes,
                  },
                },
              ],
            },
          },
        ],
      };
    }
  }
}
